import { hooks } from '@approvalmax/utils';
import { domain } from 'modules/data';
import { useEffect } from 'react';
import { routingService } from 'services/routing';
import { useSignInWith } from 'shared/hooks/(auth)/useSignInWith/useSignInWith';
import { getPath, Path } from 'urlBuilder';

export const useLoginWithXeroLauncherPageData = () => {
    const [tenantId] = hooks.useQueryParam('tenantId');

    const { onSignInWith } = useSignInWith({
        startingPoint: domain.SsoStartingPoint.ApprovalMax,
        tenantId,
    });

    useEffect(() => {
        if (tenantId) {
            onSignInWith(domain.OAuthProvider.Xero);
        } else {
            routingService.replace(getPath(Path.login));
        }
    }, [tenantId, onSignInWith]);
};
